import { memo } from 'react';

function LeftSideLayout() {
	return <></>;
}

export default memo(LeftSideLayout);
